import { ChevronLeft, Loader2 } from "lucide-react";
import { useState } from "react";
import { authService } from "../../services/auth.service";

export function RecoverPassword({ onBack, onSent }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleRecover = async (e) => {
    e.preventDefault();
    if (!email) return;
    setError("");
    setLoading(true);
    try {
      // The backend responds generically whether or not the account exists,
      // so we always advance to the code-entry step.
      await authService.forgotPassword({ email });
      onSent(email);
    } catch (err) {
      setError(err?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col md:p-8 px-2 py-3 h-full">
      <button
        onClick={onBack}
        className="mb-8 w-10 h-10 flex items-center justify-start rounded-full hover:bg-gray-50"
      >
        <ChevronLeft size={28} color="#0A4730" />
      </button>

      <h1 className="md:text-2xl text-xl font-black uppercase mb-4 text-center">
        Recover Password
      </h1>

      <p className="text-gray-500 text-[15px] mb-10 text-center">
        Enter your email and we'll send you a one-time reset code.
      </p>

      <form onSubmit={handleRecover} className="space-y-5">
        <input
          type="email"
          placeholder="Email"
          className="w-full bg-[#F3F4F6] rounded-xl p-4 outline-none"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        {error && <p className="text-sm text-red-500">{error}</p>}

        <button
          type="submit"
          disabled={loading}
          className="btn btn-primary font-bold py-4 rounded-xl w-full flex items-center justify-center gap-2 disabled:opacity-60"
        >
          {loading && <Loader2 size={18} className="animate-spin" />}
          {loading ? "Sending…" : "Send reset code"}
        </button>
      </form>
    </div>
  );
}
